module.exports = __webpack_public_path__ + "img/arrowMore.d24fcb26.svg";